import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  centerAlign: {
    alignItems: 'center',
  },
  iconButtonColor: {
    marginLeft: 30,
    color: theme.palette.neutralDark,
  },
  countColor: {
    color: 'white',
  },
  disabledColor:{
    backgroundColor: theme.palette.neutralLighter
  }
}));
